
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as InfoIconComponent } from "./info-icon.svg";

export const InfoIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <InfoIconComponent {...props} />;
};
